import type { TimelineItem } from "../../data/site";
import { Card } from "../ui/Card";
import "./timeline.css";

export function Activities({ items }: { items: TimelineItem[] }) {
  return (
    <Card>
      <div className="timeline">
        {items.map((x) => (
          <div className="timeline__row" key={`${x.time}-${x.detail}`}>
            <div className="timeline__time">{x.time}</div>
            <div className="timeline__detail">{x.detail}</div>
          </div>
        ))}
      </div>
    </Card>
  );
}

